import Richtext from '@tmh-website/components/shared/Richtext';
import { Color } from '@tmh-website/shared/colors';
import styled from 'styled-components';

export const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -4px;
  @media (${props => props.theme.breakpoint.sm.up}) {
    justify-content: flex-start;
    margin: 0 -4px -4px;
  }

  a {
    transition: opacity ${props => props.theme.transitionTiming};

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.6;
    }
  }
`;

export const LogoContainer = styled.div`
  position: relative;
  width: 52px;
  height: 34px;
  padding: 4px 5px;
  margin: 4px;
  background-color: ${props => props.theme.color[Color.Neutral_0_White]};
  border-radius: ${props => props.theme.borderRadius.small};
`;

export const Logo = styled.img`
  position: absolute;
  top: 4px;
  left: 5px;
  width: calc(100% - 10px);
  height: calc(100% - 8px);
  object-fit: contain;
`;

export const Certificate = styled.img`
  max-width: 75px;
  height: auto;
  margin: 8px;
  object-fit: contain;
`;

export const Text = styled(Richtext)`
  margin-top: 10px;
  font-size: 11px;
`;
